export default __webpack_public_path__ + "static/media/有机物.0849d98d.png";